export default "__VITE_ASSET__Dhy1DVi7__"